<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Joueurs</label>
      </div>
      <select v-model="dataForm.joueur_id"
              class="custom-select"
              name="buteur_joueur">
        <option :value="buteur.joueur_id">
          {{
            joueur ? (
                joueur.prenom.charAt(0).toUpperCase() + joueur.prenom.slice(1).toLowerCase() + ' ' +
                joueur.postnom.charAt(0).toUpperCase() + joueur.postnom.slice(1).toLowerCase() + ' ' +
                joueur.nom.charAt(0).toUpperCase() + joueur.nom.slice(1).toLowerCase()
            ) : 'Choisissez un joueur...'
          }}
        </option>
        <option :value="buteur.joueur_id">-------------------------------------</option>
        <option :key="joueur.joueur_id.slice(5,15)"
                :value="joueur.joueur_id"
                v-for="joueur in joueurs">
        {{ joueur.prenom.charAt(0).toUpperCase() + joueur.prenom.slice(1).toLowerCase() }}
          {{ joueur.postnom.charAt(0).toUpperCase() + joueur.postnom.slice(1).toLowerCase() }}
          {{ joueur.nom.charAt(0).toUpperCase() + joueur.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nombre de buts</label>
      </div>
      <input v-model="dataForm.nombre_buts"
             class="form-control"
             name="buteur_nombre_buts"
             placeholder="Entrez le nombre de buts"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Match</label>
      </div>
      <select v-model="dataForm.match_id"
              class="custom-select"
              name="buteur_match">
        <option :value="buteur.match_id">
          {{
            (equipes && match) ?
                (
                    equipes.filter((equipe) => equipe.equipe_id === match.equipe_a_id)[0].nom.toUpperCase() + ' vs ' +
                    equipes.filter((equipe) => equipe.equipe_id === match.equipe_b_id)[0].nom.toUpperCase() + ' (' +
                    (new Date(match.date_rencontre).toLocaleDateString() + match.temps_rencontre) + ')'
                ) : 'Choisissez un match...'
          }}
        </option>
        <option :value="buteur.match_id">--------------------------------------------------</option>
        <option :key="match_joue.match_id.slice(5,15)"
                :value="match_joue.match_id"
                v-for="match_joue in matchs">
          {{
            (equipes) ?
                (
                    equipes.filter((equipe) => equipe.equipe_id === match_joue.equipe_a_id)[0].nom.toUpperCase() + ' vs ' +
                    equipes.filter((equipe) => equipe.equipe_id === match_joue.equipe_b_id)[0].nom.toUpperCase() + ' (' +
                    (new Date(match_joue.date_rencontre).toLocaleDateString() + match_joue.temps_rencontre) + ')'
                ) : ''
          }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Saisons</label>
      </div>
      <select v-model="dataForm.saison_id"
              class="custom-select"
              name="buteur_saison">
        <option :value="buteur.saison_id">
          {{saison ? (saison.annee_debut + ' - ' +
                      saison.annee_fin ) :
                      'Choisissez une saison...'
          }}
        </option>
        <option :value="buteur.saison_id">-------------------------------------</option>
        <option :key="saison.saison_id.slice(5,15)"
                :value="saison.saison_id"
                v-for="saison in saisons">
          {{ saison.annee_debut }} - {{ saison.annee_fin  }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Commentaires</label>
      </div>
      <textarea v-model="dataForm.commentaires"
                class="form-control"
                name="buteur_commentaires"
                placeholder="Entrez un court commentaire sur le buteur"
                type="email">
      </textarea>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Update",
  props: {
    buteur: {
      type: Object
    }
  },
  data() {
    return {
      joueurs: null,
      saisons: null,
      joueur: null,
      saison: null,
      equipes: null,
      matchs: null,
      match: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        joueur_id: '',
        saison_id: '',
        match_id: '',
        nombre_buts: '',
        commentaires: '',
        table: 'buteurs',
        table_id: this.buteur.buteur_id,
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPutData',
    ]),
    onSubmit() {
      this.resetDefaultValues()
      this.axiosPutData(this.dataForm)
          .then((data) => {
            if(data.status === 204)
              this.messageSuccess = "Buteur modifié avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de la modification du buteur !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de la modification du buteur !"
          })
    },
    resetDefaultValues() {
      if(this.dataForm.joueur_id === '')
        this.dataForm.joueur_id = this.buteur.joueur_id
      if(this.dataForm.saison_id === '')
        this.dataForm.saison_id = this.buteur.saison_id
      if(this.dataForm.nombre_buts === '')
        this.dataForm.nombre_buts = this.buteur.nombre_buts
      if(this.dataForm.commentaires === '')
        this.dataForm.commentaires = this.buteur.commentaires
      if(this.dataForm.match_id === '')
        this.dataForm.match_id = this.buteur.match_id
    },
    setDefaultValues() {
      const buteur = Object.assign({}, this.buteur);
      this.dataForm.joueur_id = buteur.joueur_id
      this.dataForm.saison_id = buteur.saison_id
      this.dataForm.nombre_buts = buteur.nombre_buts
      this.dataForm.commentaires = buteur.commentaires
      this.dataForm.match_id = buteur.match_id
    }
},
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    this.setDefaultValues()
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.joueurs = data
        })
    //
    this.axiosGetAllData({
      table: 'matchs_joues'
    })
        .then((data) => {
          this.matchs = data.data
          this.match = this.matchs.filter((match) => match.match_id === this.buteur.match_id)[0]
        })
        .catch((data) => {
          this.matchs = data
        })
    //
    this.axiosGetAllData({
      table: 'joueurs'
    })
        .then((data) => {
          this.joueurs = data.data
          this.joueur = this.joueurs.filter((joueur) => joueur.joueur_id === this.buteur.joueur_id)[0]
        })
        .catch((data) => {
          this.joueurs = data
        })
    //
    this.axiosGetAllData({
      table: 'saisons'
    })
        .then((data) => {
          this.saisons = data.data
          this.saison = this.saisons.filter((saison) => saison.saison_id === this.buteur.saison_id)[0]
        })
        .catch((data) => {
          this.saisons = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/buteurs/components/Update.vue